import { render } from "./Dashboard.vue?vue&type=template&id=24e71ecf&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=24e71ecf&lang=scss&scoped=true"

import exportComponent from "/builds/optelgroup/exploration/reusable-components/supply-chain-simulator/prototype/iscp-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e71ecf"]])

export default __exports__